import qs from 'qs';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const useQueryParams = <TQueryParams>(): {
  queryParams: TQueryParams;
  removeQueryParams: (queryParams: (keyof TQueryParams)[]) => void;
  setQueryParams: (queryParams: TQueryParams) => void;
  updateQueryParams: (queryParams: TQueryParams) => void;
} => {
  const history = useHistory();

  const location = useLocation();

  const queryParams = useMemo<TQueryParams>(
    () => qs.parse(location.search.replace(/^\?/, ''), { ignoreQueryPrefix: true }) as unknown as TQueryParams,
    [location.pathname, location.search],
  );

  const updateQueryParams = (appliedQueryParams: TQueryParams) => {
    history.replace({
      pathname: location.pathname,
      search: qs.stringify(
        {
          ...queryParams,
          ...appliedQueryParams,
        },
        { addQueryPrefix: false },
      ),
    });
  };

  const setQueryParams = (appliedQueryParams: TQueryParams) => {
    history.replace({
      pathname: location.pathname,
      search: qs.stringify(
        {
          ...appliedQueryParams,
        },
        { addQueryPrefix: false },
      ),
    });
  };

  const removeQueryParams = (keys: (keyof TQueryParams)[]) => {
    const newQueryParams = { ...queryParams };

    keys.forEach(key => {
      delete newQueryParams[key];
    });

    history.replace({
      pathname: location.pathname,
      search: qs.stringify(newQueryParams, { addQueryPrefix: false }),
    });
  };

  return {
    queryParams: queryParams,
    removeQueryParams: removeQueryParams,
    setQueryParams: setQueryParams,
    updateQueryParams: updateQueryParams,
  };
};
